// extracted by mini-css-extract-plugin
module.exports = {"simpleUploadContainer":"SimpleImageUpload_simpleUploadContainer__27wJy","uploadedFile":"SimpleImageUpload_uploadedFile__QtWX7","buttons":"SimpleImageUpload_buttons__1ZHW8"};